import styled from 'styled-components';

export const PanoRoot = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	border: 10px solid white;
`;

export const ChildrenCloak = styled.div`
	display: none;
`;